"use strict";

module.exports.keys = {
    key_enter: 10,
    key_return: 13,
    key_space: 32,
    key_a: 65,
    key_e: 69,
    key_s: 83,
    key_u: 85,
    key_m: 77,
    key_esc: 27,
    key_down: 40,
    key_up: 38,
    key_f2: 113,
};

module.exports.ctrlMeta = function (event) {
    return event.ctrlKey || event.metaKey;
};
